import React, { useRef, useState, useEffect } from 'react';
import { connect } from 'umi';
import { Button, Popconfirm, MessageBox, message } from 'kenshin';
import TablePro from '@/components/TablePro';
import ModalFormPro from '@/components/ModalFormPro';
import UpdateForm from './components/UpdateForm';
import EllipsisTooltip from '@/components/EllipsisTooltip';

/**
 * 岗位管理页面
 * 对应接口:
 * - 分页查询: /waper/erp/pc/post/getpostpage
 * - 新增: /waper/erp/pc/post/addpost
 * - 修改: /waper/erp/pc/post/updatepost
 * - 删除: /waper/erp/pc/post/deletepost
 */
const Position = (props) => {
  const { dispatch, systemOrgani, position } = props;
  const { employeeAll } = systemOrgani;

  const [modalVisible, setModalVisible] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const actionRef = useRef();

  // 获取员工列表数据，用于下拉选择
  useEffect(() => {
    dispatch({
      type: 'systemOrgani/getAllEmployee',
    });
  }, []);

  const handleAdd = () => {
    setCurrentRecord(null);
    setModalVisible(true);
  };

  const handleEdit = (record) => {
    setCurrentRecord(record);
    setModalVisible(true);
  };

  const handleDelete = (postId) => {
    MessageBox.confirm({
      title: '确认操作',
      content: '确认删除？删除后无法恢复',
      onOk: () => {
        dispatch({
          type: 'position/deletePost',
          payload: { postId },
        }).then((res) => {
          if (res?.success) {
            actionRef.current?.reload();
          }
        });
      },
    });
  };

  const handleModalOk = (values) => {
    const isEdit = !!currentRecord;
    const type = isEdit ? 'position/updatePost' : 'position/addPost';
    const payload = isEdit
      ? { ...values, postId: currentRecord.postId }
      : values;
    payload.employeeList = payload.employeeList.map((id) => ({
      id: id.split('-')[1],
    }));
    dispatch({
      type,
      payload,
    }).then((res) => {
      if (res?.success) {
        setModalVisible(false);
        actionRef.current?.reload();
      }
    });
  };

  const columns = [
    {
      title: '岗位名称',
      dataIndex: 'postName',
      key: 'postName',
    },
    {
      title: '岗位描述',
      dataIndex: 'postDesc',
      key: 'postDesc',
    },
    {
      title: '关联员工',
      dataIndex: 'employeeList',
      key: 'employeeList',
      // 显示员工姓名，假设返回的数据结构是 [{ label: 'Name', value: 'ID' }]
      render: (text) => {
        if (Array.isArray(text)) {
          return text.map((item) => item.label || item.value).join('，');
        }
        return '-';
      },
    },
    {
      dataIndex: 'taskTagList',
      title: '标签',
      render(taskTagList) {
        return (
          <EllipsisTooltip
            value={taskTagList?.map((item) => item.value).join('、')}
            width={100}
          />
        );
      },
    },
    {
      title: '操作',
      valueType: 'option',
      key: 'option',
      render: (_, record) => [
        <Button key="edit" type="text" onClick={() => handleEdit(record)}>
          修改
        </Button>,
        <Button
          key="delete"
          type="text"
          style={{ color: 'red' }}
          onClick={() => handleDelete(record.postId)}
        >
          删除
        </Button>,
      ],
    },
  ];

  return (
    <>
      <TablePro
        headerTitle="岗位管理"
        actionRef={actionRef}
        request="position/getPostPage"
        columns={columns}
        rowKey="postId"
        data={position.postList}
        curColumns
        extra={() => [
          <Button type="primary" key="add" onClick={handleAdd}>
            新增
          </Button>,
        ]}
      />
      <UpdateForm
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleModalOk}
        initialValues={currentRecord}
        employeeList={employeeAll || []}
      />
    </>
  );
};

export default connect(({ position, systemOrgani, loading }) => ({
  position,
  systemOrgani,
  loading: loading.models.position,
}))(Position);
